var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoombox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.75 14C5.75 14.9665 6.5335 15.75 7.5 15.75C8.4665 15.75 9.25 14.9665 9.25 14C9.25 13.3019 8.84124 12.6993 8.25 12.4184V14C8.25 14.4142 7.91421 14.75 7.5 14.75C7.08579 14.75 6.75 14.4142 6.75 14V12.4184C6.15876 12.6993 5.75 13.3019 5.75 14Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.75 14C14.75 14.9665 15.5335 15.75 16.5 15.75C17.4665 15.75 18.25 14.9665 18.25 14C18.25 13.7937 18.2143 13.5957 18.1487 13.4119L17.0303 14.5303C16.7374 14.8232 16.2626 14.8232 15.9697 14.5303C15.6768 14.2374 15.6768 13.7626 15.9697 13.4697L17.0881 12.3513C16.9043 12.2857 16.7063 12.25 16.5 12.25C15.5335 12.25 14.75 13.0335 14.75 14Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.25 5.75V8H4C2.89543 8 2 8.89543 2 10V18C2 19.1046 2.89543 20 4 20H20C21.1046 20 22 19.1046 22 18V10C22 8.89543 21.1046 8 20 8H19.75V5.75C19.75 4.23122 18.5188 3 17 3H7C5.48122 3 4.25 4.23122 4.25 5.75ZM7 4.5H17C17.6904 4.5 18.25 5.05964 18.25 5.75V8H5.75V5.75C5.75 5.05964 6.30964 4.5 7 4.5ZM7.5 10.75C9.29493 10.75 10.75 12.2051 10.75 14C10.75 15.7949 9.29493 17.25 7.5 17.25C5.70507 17.25 4.25 15.7949 4.25 14C4.25 12.2051 5.70507 10.75 7.5 10.75ZM16.5 17.25C14.7051 17.25 13.25 15.7949 13.25 14C13.25 12.2051 14.7051 10.75 16.5 10.75C18.2949 10.75 19.75 12.2051 19.75 14C19.75 15.7949 18.2949 17.25 16.5 17.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoombox);
export default __webpack_public_path__ + "static/media/boombox.5d94a93071ca5afcaf393ce311e18735.svg";
export { ForwardRef as ReactComponent };